import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { VendorService } from '../../../../app/_services/vendor.services';
import { SnackbarService } from '../../../_service/message-service';
import { LoaderService } from 'src/app/loader.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/_services';
declare var $: any;

@Component({
  selector: 'telio-vendor-details',
  templateUrl: './vendor-details.component.html',
  styleUrls: ['./vendor-details.component.scss']
})
export class VendorDetailsComponent implements OnInit {

  lat = 17.448294;
  lng = 78.391487;
  tabOneActive = false;
  tabTwoActive = false;
  public iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';
  selectedStation: any;
  stations;
  VendorID: any;
  userStatus = false;
  stationsActive = false
  isClicked; false;
  firstTab = false;
  secondTab = false;
  vendordetails = {};
  stnid: any = {};
  deleteid: any;
  boxId;
  operatorId: any;
  boxStatus = '';
  selectedIndex = 0;
  routedComponent: string;
  userId;
  loadMappingTab = false;
  mappingTab = false;
  resultTabs = []
  tabsRouteID = MenuRouteID.TABS;
  groupType = '';
  availableTabs = [
    { id: MenuRouteID.TABS.OPERATOR_DETAILS, enable: true },
    { id: MenuRouteID.TABS.STATION_DETAILS, enable: true }
  ];
  tempRoute = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vendorservice: VendorService,
    private toastr: SnackbarService,
    public loaderService: LoaderService,
    private userInfoService: UserInfoService,
    readonly translate: TranslateService,
    private authenticationService: AuthenticationService
  ) {
    this.VendorID = JSON.parse(this.router.getCurrentNavigation().extras.queryParams.vendorid);
    this.selectedIndex = JSON.parse(this.router.getCurrentNavigation().extras.queryParams.index)
    this.routedComponent = this.router.getCurrentNavigation().extras.queryParams.routedName
    !!this.routedComponent && this.authenticationService.setRouteFromVendorDetails(this.routedComponent)
    this.tempRoute = this.authenticationService.getRouteFromVendorDetails();
    this.userId = this.router.getCurrentNavigation().extras.queryParams.userId
    this.mappingTab = this.router.getCurrentNavigation().extras.queryParams.mappingTab
    this.groupType = this.router.getCurrentNavigation().extras.queryParams.groupType
  }

  ngOnInit() {
    this.stationsActive = false
    this.getvendorinfobyvendorid(this.VendorID);
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
  }

  tabClick(tab) {
    if (tab.index == 0) {
      this.firstTab = true
    }
    if (tab.index == 1) {
      this.stationsActive = true
      this.secondTab = true
      this.isClicked = true;
      this.loadMappingTab = true;
    }
  }

  toggleclassone() {
    this.tabOneActive = true;
    this.tabTwoActive = false
  }

  toggleclasstwo() {
    this.tabTwoActive = true;
    this.tabOneActive = false;
  }

  closedelete() {
    this.deleteid = {};
    $("#deleteStation").modal('hide');
  }

  getvendorinfobyvendorid(id) {
    this.vendorservice.getvendorinfobyvendorid(id,this.groupType).subscribe(
      (resp: any) => {
        Object.keys(resp).map(x => {
          if (resp[x] !== false) {
            (!resp[x] || resp[x] == '') ? resp[x] = 'NA' : null;
          }
        })
        this.vendordetails = resp;
      });
  }

  closeupdate() {
    $("#updateAlert").modal('hide');
  }

  // view station details
  stndetails(stndata) {
    this.stnid = stndata.chargeboxId;
    this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.stnid) } })
  }

  deletestation(id) {
    this.deleteid = id;
    $("#deleteStation").modal('show');
  }

  updateStation(ele) {
    this.operatorId = ele.chargeboxId;
    this.boxId = ele.vendorId;
    if (ele.status == "available") {
      this.boxStatus = "unavailable"
    }
    if (ele.status == "unavailable") {
      this.boxStatus = "available"
    }
    $("#updateAlert").modal('show');
  }

  topback() {
    if (this.tempRoute == 'stationlist') {
      this.router.navigate(['/dashboard/stations', { routeID: MenuRouteID.STATIONS }], { queryParams: { "state": true } });
    }
    else if (this.tempRoute == 'chargingTransactions') {
      this.router.navigate(['/dashboard/charging-transactions', { routeID: MenuRouteID.CHARGING_TRANSACTION }]);
    }
    else if (this.tempRoute == 'cmsUsers') {
      this.router.navigate(['/dashboard/user-management/users', { routeID: MenuRouteID.CMS_USERS }]);
    }
    else {
      this.router.navigate(['/dashboard/operators', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    }
  }
}
